import { AccessorsMutatorsDecorator, Model } from '../../helpers';
import { Guest } from './guests.model';

/**
 * @class ReservationTransaction
 *
 * @property {number} id
 * @property {string} identifier
 * @property {number} type
 * @property reservation
 * @property notes
 * @property quantity
 * @property debit
 * @property credit
 * @property created_at
 * @property {Guest} guest
 * @property room
 * @property subject
 * @property subject_type
 * @property room_name
 * @property is_refund
 * @property is_void
 * @property item
 * @property description
 * @property is_daily_system
 * @property notes_formatted
 * @property is_deleted
 * @property created_at_tz
 * @property {number} voucher_id
 * @property {string} voucher_ident
 */
export class ReservationTransaction extends Model {

    setGuest(value = null) {

        if (!value) {

            return null;
        }

        return value instanceof Guest ? value : new Guest(value);
    }
}

AccessorsMutatorsDecorator(
    'id',
    'identifier',
    'type',
    'reservation',
    'notes',
    'quantity',
    'debit',
    'credit',
    'created_at',
    'guest',
    'room',
    'subject',
    'subject_type',
    'room_name',
    'is_refund',
    'is_void',
    'item',
    'description',
    'is_daily_system',
    'notes_formatted',
    'is_deleted',
    'created_at_tz',
    'voucher_id',
    'voucher_ident',
    'voucher_type',
)(ReservationTransaction);



// WEBPACK FOOTER //
// ./src/pms-api/models/reservation-transaction.model.js